

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M13.75 0c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75h-6C2.32 21.5 0 19.18 0 13.75v-6C0 2.32 2.32 0 7.75 0h6Zm0 1.5h-6C3.14 1.5 1.5 3.14 1.5 7.75v6C1.5 18.36 3.14 20 7.75 20h6c4.61 0 6.25-1.64 6.25-6.25v-6c0-4.61-1.64-6.25-6.25-6.25Zm-3 4.5c.41 0 .75.34.75.75V10h3.25c.41 0 .75.34.75.75s-.34.75-.75.75H11.5v3.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V11.5H6.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H10V6.75c0-.41.34-.75.75-.75Z"}, []), "\n"]);
};

        